import { keys as parentKeys } from '@copro/api';
import type { ExistingMatchKind, InboxEmailStatus } from '../types/inbox.types';

export const keys = {
  inbox: [...parentKeys.all, 'inbox'] as const,
  list: (spaceId: string, status?: InboxEmailStatus) =>
    [...keys.inbox, 'list', spaceId, status ?? 'all'] as const,
  listSearch: (spaceId: string, status: InboxEmailStatus | undefined, search: string) =>
    [...keys.list(spaceId, status), { search }] as const,
  count: (spaceId: string, status?: InboxEmailStatus) =>
    [...keys.inbox, 'count', spaceId, status ?? 'all'] as const,
  countSearch: (spaceId: string, status: InboxEmailStatus | undefined, search: string) =>
    [...keys.count(spaceId, status), { search }] as const,
  detail: (emailId: string) => [...keys.inbox, 'detail', emailId] as const,
  syncStatus: (spaceId: string) => [...keys.inbox, 'syncStatus', spaceId] as const,
  aiSettings: (spaceId: string) => [...keys.inbox, 'aiSettings', spaceId] as const,
  senderProvider: (spaceId: string, fromEmail: string) =>
    [...keys.inbox, 'senderProvider', spaceId, fromEmail.toLowerCase()] as const,
  existingMatch: (kind: ExistingMatchKind, id: string) => [...keys.inbox, 'existingMatch', kind, id] as const,
};
